"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimitGambleBaseView = void 0;
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const GambleAssetConfig_1 = require("../config/GambleAssetConfig");
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const GuiLayout_1 = require("@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout");
const gsap_1 = require("gsap");
const NoLimitGamblePlugin_1 = require("../NoLimitGamblePlugin");
const GambleEvents_1 = require("../config/GambleEvents");
class NoLimitGambleBaseView extends PIXI.Container {
    /**
     * @constructs
     * @param gambleClickCb
     * @param collectClickCb
     */
    constructor(gambleClickCb, collectClickCb) {
        super();
        this._gambleClickCallback = gambleClickCb;
        this._collectClickCallback = collectClickCb;
        this.init();
    }
    /**
     * @description Resize handler.
     */
    onResize() {
        const bounds = NolimitApplication_1.NolimitApplication.screenBounds;
        if (NolimitApplication_1.NolimitApplication.isLandscape) {
            this._buttonContainer.position.set(bounds.right - this._buttonContainer.width - 25, bounds.bottom - this._buttonContainer.height - 340);
        }
        else {
            this._buttonContainer.position.set(bounds.right - this._buttonContainer.width - 15, bounds.bottom - this._buttonContainer.height - 225);
        }
    }
    /**
     * @description When gamble button is clicked.
     */
    onGambleButtonClick() {
        this._gambleButton.enable(false);
        this.killTimeline();
    }
    /**
     * @description To disable the buttons.
     */
    disableButtons() {
        this._gambleButton.enable(false);
        this._collectButton.enable(false);
    }
    /**
     * @description To enable the buttons.
     */
    enableButtons() {
        this._gambleButton.enable(true);
        this._collectButton.enable(true);
    }
    /**
     * @description To enable collect button.
     */
    enableCollectButton() {
        this._collectButton.enable(true);
    }
    /**
     * @description To show the view.
     */
    show() {
        this._toggleTl.restart();
        this.visible = true;
    }
    /**
     * @description To hide the view.
     */
    hide() {
        this.disableButtons();
        this.killTimeline();
        this.visible = false;
    }
    /**
     * @description To init the view.
     */
    init() {
        this.createButtons();
        this.visible = false;
    }
    /**
     * @description To create the buttons.
     */
    createButtons() {
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xFFFFFFFF, 0xFFFFFFFF, 0xFFFFFFFF, 0x33FFFFFF), onIconsGamble = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.GAMBLE_BUTTON))), onIconsCollect = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.COLLECT_BUTTON))), gambleBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleBaseView.GAMBLE_BUTTON, onIconsGamble, colors), collectBtn = new IconToggleButton_1.IconToggleButton(NoLimitGambleBaseView.COLLECT_BUTTON, onIconsCollect, colors);
        gambleBtn.addClickCallback(() => this._gambleClickCallback());
        gambleBtn.toggled = false;
        this._gambleButton = gambleBtn;
        collectBtn.addClickCallback(() => this._collectClickCallback());
        collectBtn.toggled = false;
        this._collectButton = collectBtn;
        this.createButtonToggle();
        this._buttonContainer = new PIXI.Container();
        this._buttonContainer.addChild(this._gambleButton, this._collectButton, this._gambleToggle, this._collectToggle);
        GuiLayout_1.GuiLayout.align([this._gambleButton, this._collectButton], 10, GuiLayout_1.Align.LEFT, GuiLayout_1.Direction.HORIZONTAL);
        this._gambleToggle.position.set(this._gambleButton.position.x, this._gambleButton.position.y);
        this._collectToggle.position.set(this._collectButton.position.x, this._collectButton.position.y);
        this.addChild(this._buttonContainer);
    }
    /**
     * @description To create the blinking toggle timeline for the buttons.
     */
    createButtonToggle() {
        const gambleToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.GAMBLE_BUTTON_TOGGLE)), collectToggle = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(GambleAssetConfig_1.GambleAssetConfig.COLLECT_BUTTON_TOGGLE)), toggleTl = new gsap_1.TimelineLite({
            paused: true,
            onComplete: () => { this._toggleTl.restart(); }
        }), duration = 0.4;
        gambleToggle.visible = false;
        collectToggle.visible = false;
        toggleTl.add(() => {
            gambleToggle.visible = true;
            const soundConfig = {
                name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.GAMBLE_TOGGLE,
                loop: false
            };
            NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_KEYPAD_SOUND, soundConfig);
        });
        toggleTl.add(() => {
            gambleToggle.visible = false;
            collectToggle.visible = true;
            const soundConfig = {
                name: NoLimitGamblePlugin_1.NoLimitGamblePlugin.COLLECT_TOGGLE,
                loop: false
            };
            NolimitApplication_1.NolimitApplication.events.trigger(GambleEvents_1.GambleEvents.GAMBLE_PLAY_KEYPAD_SOUND, soundConfig);
        }, duration);
        toggleTl.add(() => { collectToggle.visible = false; }, (2 * duration));
        this._toggleTl = toggleTl;
        this._gambleToggle = gambleToggle;
        this._collectToggle = collectToggle;
    }
    /**
     * @description To kill the toggle timeline.
     */
    killTimeline() {
        this._toggleTl.pause();
        this._toggleTl.kill();
        this._gambleToggle.visible = false;
        this._collectToggle.visible = false;
    }
}
exports.NoLimitGambleBaseView = NoLimitGambleBaseView;
NoLimitGambleBaseView.GAMBLE_BUTTON = "gambleButton";
NoLimitGambleBaseView.COLLECT_BUTTON = "collectButton";
//# sourceMappingURL=NoLimitGambleBaseView.js.map